import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { map, switchMap } from 'rxjs/operators';
import { ProjectsService } from '../projects.service';
import { ExistsResponse } from '../../shared/domain/ExistsResponse';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { timer } from 'rxjs';
import { debounceTime } from '../../shared/constants/constants';

const checkIfNameExists = (projectsService: ProjectsService, inputValue: any): Observable<any> =>
  projectsService
    .checkIfNameExists(inputValue)
    .pipe(map(({ exists }: ExistsResponse) => (exists ? { unique: true } : null)));

export const ValidateUniqueName = (projectsService: ProjectsService, startValue: string): AsyncValidatorFn => ({
  value: inputValue
}: AbstractControl): Observable<any> =>
  timer(debounceTime).pipe(
    switchMap(() => (startValue === inputValue ? of(null) : checkIfNameExists(projectsService, inputValue)))
  );
